import { RESUME_DRAFT_LEGACY } from '@confluence/named-routes';

import type { BreadcrumbsType } from '../hooks/useEditorBreadcrumbs';

// The breadcrumbs prop should come from useEditorBreadcrumbs
type GetNearestVisibleAncestorProps = {
	breadcrumbs: BreadcrumbsType;
	fallbackUrl: string;
};

// Gets the nearest visible ancestor of page from breadcrumbs.
export const getNearestVisibleAncestor = ({
	breadcrumbs,
	fallbackUrl,
}: GetNearestVisibleAncestorProps) => {
	let url = fallbackUrl;
	// Loop through all breadcrumbs from bottom up and find the first view page url
	if (breadcrumbs) {
		for (let index = breadcrumbs.length - 1; index >= 0; index--) {
			const crumb = breadcrumbs[index];
			const ancestorUrl = crumb?.url;
			if (ancestorUrl && !RESUME_DRAFT_LEGACY.match(ancestorUrl)) {
				url = ancestorUrl;
				break;
			}
		}
	}
	return url;
};
